import { render, staticRenderFns } from "./InstanceTenants.vue?vue&type=template&id=049a5242&scoped=true&"
import script from "./InstanceTenants.vue?vue&type=script&lang=js&"
export * from "./InstanceTenants.vue?vue&type=script&lang=js&"
import style0 from "./InstanceTenants.vue?vue&type=style&index=0&id=049a5242&prod&scoped=true&lang=css&"
import style1 from "./InstanceTenants.vue?vue&type=style&index=1&id=049a5242&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049a5242",
  null
  
)

export default component.exports